import React, { useRef } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { MindMapHeader } from "./MindMapHeader";
import { MindMapCanvas } from "./MindMapCanvas";
import { useMindMapExport } from "./hooks/useMindMapExport";
import type { MindMapNode, ExpandedMap } from "./types";

interface MindMapModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  root: MindMapNode;
  expanded: ExpandedMap;
  onToggle: (id: string) => void;
}

export const MindMapModal: React.FC<MindMapModalProps> = ({
  open,
  onClose,
  title,
  root,
  expanded,
  onToggle,
}) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const { exportPNG } = useMindMapExport(exportRef, title);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[90vh] w-[95vw] max-w-none flex-col gap-0 p-0 sm:rounded-2xl [&>button:last-child]:hidden">
        <div ref={exportRef} className="flex flex-col flex-1 min-h-0">
          <MindMapHeader
            title={title}
            mode="expanded"
            onDownload={exportPNG}
            onToggleExpand={onClose}
          />
          <div className="flex-1 min-h-0 overflow-hidden bg-muted/20">
            <MindMapCanvas
              root={root}
              expanded={expanded}
              onToggle={onToggle}
              className="h-full min-h-0"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
